import { render, staticRenderFns } from "./CandidateInfoModal.vue?vue&type=template&id=5a41ae45"
import script from "./CandidateInfoModal.vue?vue&type=script&lang=js"
export * from "./CandidateInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports